import { render, staticRenderFns } from "./EditActivity.vue?vue&type=template&id=1256d358&scoped=true&"
import script from "./EditActivity.vue?vue&type=script&lang=js&"
export * from "./EditActivity.vue?vue&type=script&lang=js&"
import style0 from "./EditActivity.vue?vue&type=style&index=0&id=1256d358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256d358",
  null
  
)

export default component.exports